import { createSlice } from '@reduxjs/toolkit'

export const searchSessionKey = createSlice({
  name: 'searchSessionKey',
  initialState: '',
  reducers: {
    setSearchSessionKey: (state, action) => {
      return action?.payload
    },
  },
})

export const { setSearchSessionKey } = searchSessionKey.actions
